import { FieldInputProps, useField } from 'formik';
import { DetailedHTMLProps, InputHTMLAttributes, useState } from 'react';

import { Wrap } from './styled';

type TTextInput<T> = {
  label: string;
} & FieldInputProps<T> &
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

function TextInput<T = any>({ label, ...props }: TTextInput<T>): JSX.Element {
  const [field, meta] = useField(props);

  const [isFocus, setIsFocus] = useState(false);
  const handleSetFocusTrue = () => setIsFocus(true);
  const handleSetFocusFalse = () => setIsFocus(false);

  return (
    <Wrap
      className={`${isFocus ? 'input-focused' : ''} ${
        meta.value ? 'input-has-value' : ''
      }`}
    >
      <label htmlFor={props.id}>
        {label} {props.required ? <span className="text-yellow">*</span> : ''}
      </label>
      <input
        {...props}
        {...field}
        onFocus={handleSetFocusTrue}
        onBlur={handleSetFocusFalse}
      />
    </Wrap>
  );
}

export default TextInput;
